<template>
  <div ref="brandpinChartNet2"></div>
</template>

<script>
import * as d3 from "d3";
import debounce from "lodash";



export default {
  name: "BrandpinChartNet2",
  data() {
    return {
      nodes: [
        // { id: "네스프레소", group: 1 },
        // { id: "라인브랜드", group: 2 },
        // { id: "상품명", group: 2 },
        // { id: "광고/인물", group: 2 },
        // { id: "네스프레소버츄오", group: 3 },
        // { id: "버츄오", group: 3 },
        // { id: "버츄오팦gcv2", group: 3 },
        // { id: "김고은네스프레소", group: 3 },
        // { id: "조지클루니커피", group: 3 },
        // { id: "돌체구스토", group: 3 },
      ],
      links: [
        // { source: "네스프레소", target: "라인브랜드" },
        // { source: "네스프레소", target: "상품명" },
        // { source: "네스프레소", target: "광고/인물" },
        // { source: "라인브랜드", target: "네스프레소버츄오" },
        // { source: "라인브랜드", target: "버츄오" },
        // { source: "라인브랜드", target: "돌체구스토" },
        // { source: "상품명", target: "버츄오팦gcv2" },
        // { source: "광고/인물", target: "김고은네스프레소" },
        // { source: "광고/인물", target: "조지클루니커피" },
      ],
    };
  },
  props: {
    netChartNodes: {
      type: Array,
      default: () => [],
    },
    netChartLinks: {
      type: Array,
      default: () => [],
    }
  },
  watch: {
    netChartNodes() {
      this.updateGraph();
    }
  },
  mounted() {
    this.createGraph();

    window.addEventListener('resize', _.debounce((e) => {
      this.handleResize(e);
    }, 500));
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize(event) {
      this.updateGraph();
    },

    updateGraph() {      
      console.log('updateGraph!!!');

      let pre_svg = d3
        .select(this.$refs.brandpinChartNet2)
      pre_svg.selectAll("*").remove();

      const width = this.$refs.brandpinChartNet2.offsetWidth;
      const height = 600;

      const svg = d3
        .select(this.$refs.brandpinChartNet2)
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .style("background-color", '#E1E6EB');

      const simulation = d3
        .forceSimulation(this.netChartNodes)
        .force(
          "link",
          d3.forceLink(this.netChartLinks).id((d) => d.id).distance(function(d){
            if((d.source.id === '라인브랜드' && d.target.id === '상품명') || (d.source.id === '상품명' && d.target.id === '광고/인물') || (d.source.id === '광고/인물' && d.target.id === '라인브랜드')){
              return 50
            }else{
              // 80~240 사이 랜덤 정수
              var _distance = Math.floor(Math.random() * (240 - 80 + 1)) + 100
              return _distance
            }
          })
        )
        // .force(
        //   "link",
        //   d3.forceLink(this.netChartLinks).id((d) => d.id).distance(30)
        // )
        .force("charge", d3.forceManyBody().strength(function(d){
          if((d.group === 1) || (d.group === 2)){
              return -400
            }else{
              return -600
            }
        }))
        


        // .force("charge", d3.forceManyBody().strength(-400))
        .force("center", d3.forceCenter(width / 2, height / 2));

      const link = svg
        .append("g")
        .selectAll("line")
        .data(this.netChartLinks)
        .enter()
        .append("line")
        .attr("stroke-width", function(d){
          if (d.target.id.startsWith('sub_brand') || d.target.id.startsWith('product') || d.target.id.startsWith('person_ad') || d.target.id === "상품명" || d.target.id === "라인브랜드" || d.target.id === "광고/인물"){
            return 0
          }else{
            return 2
          }
        })
        .attr("stroke", "#aaa");

      const nodeCircles = svg
        .append("g")
        .selectAll("circle")
        .data(this.netChartNodes)
        .enter()
        .filter(d => d.group != 3)
        .append("circle")
        .attr("r", function(d){
          if (d.group ===1){
            return 10
          }else{
            return 60
          }
        })
        .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "#FFFFFF"))
        .attr('stroke', function(d){
          if (d.group === 1){
            return "none"
          }else{
            if(d.id === "라인브랜드"){
              return "#ff7f0e"
            }else if(d.id === "상품명"){
              return "#FF0000"
            }else{
              return "#008000"
            }
            
          }
        })
        .attr('stroke-width', (d) => (d.group === 1 ? "none" : 2))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        );


      var sub_brand_rank = 0
      var product_rank = 0
      var person_ad_rank = 0

      const sub_brand_color = ['#ff7f0e', '#FF9F4A', '#FF9F4A', '#FFB777', '#FFB777', '#FFB777', '#FFC999', '#FFC999', '#FFC999', '#FFC999', '#FFD6B2', '#FFD6B2', '#FFD6B2', '#FFD6B2', '#FFD6B2']
      const product_color = ['#FF0000', '#FF7070', '#FF7070', '#FF9494', '#FF9494', '#FF9494', '#FFAFAF', '#FFAFAF', '#FFAFAF', '#FFAFAF', '#FFD7D7', '#FFD7D7', '#FFD7D7', '#FFD7D7', '#FFD7D7']
      // const product_color = ['#FF0000', '#FF4040', '#FF4040', '#FF7070', '#FF7070', '#FF7070', '#FF9494', '#FF9494', '#FF9494', '#FF9494', '#FFAFAF', '#FFAFAF', '#FFAFAF', '#FFAFAF', '#FFAFAF']
      const person_ad_color = ['#008000', '#40A040', '#40A040', '#70B870', '#70B870', '#70B870', '#94CA94', '#94CA94', '#94CA94', '#94CA94', '#AFD7AF', '#AFD7AF', '#AFD7AF', '#AFD7AF', '#AFD7AF']

      



      // const sub_brand_color = ['#ff7f0e', '#FF9F4A', '#FFB777', '#FFC999', '#FFD6B2']
      // const product_color = ['#FF0000', '#FF4040', '#FF7070', '#FF9494', '#FFAFAF']
      // const person_ad_color = ['#008000', '#40A040', '#70B870', '#94CA94', '#AFD7AF']
      
      
      
      //////////////////////////////////////////////////////////////////////////////////////////////////
      const nodeRectangles = svg
        .append("g")
        .selectAll("g") // 각 노드를 위한 그룹
        .data(this.netChartNodes)
        .enter()
        .append("g")
        .filter(d => d.group === 3) // 필요한 노드만
        .call(
          d3.drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;

              svg.selectAll('.selected')
                .classed('selected', false)
                .style('stroke', '#1951DC')
                .style('stroke-width', '0');
              
              d3.select(event.sourceEvent.target.parentNode)
                .classed('selected', true)
                .style('stroke', '#1951DC')
                .style('stroke-width', '3');
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        )
        .on('click', function(d){
          d3.select(this)
            .classed('selected', true)
            .style('stroke', '#1951DC')
            .style('stroke-width', '3')
        })
        .on('mouseenter', function() {
            d3.select(this).raise()
        })
        ;
      
      
      nodeRectangles.append("rect")
        .attr("rx", 5)
        .attr("width", function(d){ 
          if(d.rank == 1){
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*30
            }else{
              return d.id.length*30
            }
          }else if(d.rank > 1 && d.rank < 4){
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*25
            }else{
              return d.id.length*25
            }
          }else if(d.rank > 3 && d.rank < 7){
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*20
            }else{
              return d.id.length*20
            }
          }else{
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*15
            }else{
              return d.id.length*15
            }
          }
          })
        .attr("height", function(d){ 
          if(d.rank == 1){
            return 70
          }else if(d.rank > 1 && d.rank < 4){
            return 50
          }else if(d.rank > 3 && d.rank < 7){
            return 42
          }else{
            return 35
          }
          })
        .attr("fill", function(d){ 
          if(d.gubun === "nothing"){
            return "none"
          }else{
            if(d.gubun === "sub_brand"){
              var color = sub_brand_color[sub_brand_rank]
              sub_brand_rank += 1
              return color
            }else if(d.gubun === "product"){
              var color = product_color[product_rank]
              product_rank += 1
              return color
            }else{
              var color = person_ad_color[person_ad_rank]
              person_ad_rank += 1
              return color
            }
          }
          });

      nodeRectangles.append("text")
        .attr("x", function(d){
          if(d.rank == 1){
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*30/2
            }else{
              return d.id.length*30/2
            }
          }else if(d.rank > 1 && d.rank < 4){
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*25/2
            }else{
              return d.id.length*25/2
            }
          }else if(d.rank > 3 && d.rank < 7){
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*20/2
            }else{
              return d.id.length*20/2
            }
          }else{
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*15/2
            }else{
              return d.id.length*15/2
            }
          }
        })
        .attr("y", function(d){
          if(d.rank == 1){
            return (70/2)
          }else if(d.rank > 1 && d.rank < 4){
            return (50/2)
          }else if(d.rank > 3 && d.rank < 7){
            return (42/2)
          }else{
            return (35/2)
          } + 5; // 약간 아래로 보정
        })
        .attr("text-anchor", "middle")
        .text((d) => (d.gubun === "nothing" ? "" : d.id))
        .attr("fill", (d) => (d.group === 3 ? "#FFFFFF" : "#414141"))
        .attr("stroke", (d) => (d.group === 3 ? "none" : "#414141"))
        .attr("stroke-width", (d) => (d.group === 3 ? "none" : 0.5))
        .style("font-size", function(d){
          if(d.group == 2){
            return 25
          }else{
            if(d.rank == 1){
              return 25
            }else if(d.rank > 1 && d.rank < 4){
              return 20
            }else if(d.rank > 3 && d.rank < 7){
              return 17
            }else{
              return 15
            }
          }
        })


      nodeRectangles.append("text")
        .attr("x", function(d){
          if(d.rank == 1){
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*30/2
            }else{
              return d.id.length*30/2
            }
          }else if(d.rank > 1 && d.rank < 4){
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*25/2
            }else{
              return d.id.length*25/2
            }
          }else if(d.rank > 3 && d.rank < 7){
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*20/2
            }else{
              return d.id.length*20/2
            }
          }else{
            if(d.id.length < 4){
              return d.freq.toLocaleString().length*15/2
            }else{
              return d.id.length*15/2
            }
          }
        })
        .attr("y", function(d){
          if(d.rank == 1){
            return (70/2)+15
          }else if(d.rank > 1 && d.rank < 4){
            return (50/2)+15
          }else if(d.rank > 3 && d.rank < 7){
            return (42/2)+15
          }else{
            return (35/2)+15
          } + 5; // 약간 아래로 보정
        })
        .attr("text-anchor", "middle")
        .attr("transform", function(d){
          if(d.group === 2)
            return `translate(0, 7)`
          else {
            if(d.rank == 1){
              return `translate(0, 5)`
            }else if(d.rank > 1 && d.rank < 4){
              return `translate(0, 2)`
            }else if(d.rank > 3 && d.rank < 7){
              return `translate(0, 1)`
            }else{
              return `translate(0, -1)`
            }
          }
        })
        .text((d) => (d.gubun === "nothing" ? "" : d.freq.toLocaleString()))
        .attr("fill", (d) => (d.group === 3 ? "#FFFFFF" : "#707070"))
        .attr("stroke", (d) => (d.group === 3 ? "none" : "#707070"))
        .attr("stroke-width", (d) => (d.group === 3 ? "none" : 0.3))
        .style("font-size", function(d){
          if(d.group == 2){
            return 17
          }else{
            if(d.rank == 1){
              return 17
            }else if(d.rank > 1 && d.rank < 4){
              return 15
            }else if(d.rank > 3 && d.rank < 7){
              return 13
            }else{
              return 11
            }
          }
        })


      const label = svg
        .append("g")
        .selectAll("text")
        .data(this.netChartNodes)
        .enter()
        .append("text")
        .attr("dy", (d) => (d.group === 2 ? 0 : 4))
        .attr("text-anchor", "middle")
        .text(function(d){
          if(d.group === 2){
            if(d.gubun === "nothing"){
              return ""
            }else{
              return d.id
            }
          }else{
            return ""
          }
        })
        .attr("fill", (d) => (d.group === 3 ? "#FFFFFF" : "#414141"))
        .attr("stroke", (d) => (d.group === 3 ? "none" : "#414141"))
        .attr("stroke-width", (d) => (d.group === 3 ? "none" : 0.5))
        .style("font-size", function(d){
          if(d.group == 2){
            return 25
          }else{
            if(d.rank == 1){
              return 25
            }else if(d.rank > 1 && d.rank < 4){
              return 20
            }else if(d.rank > 3 && d.rank < 7){
              return 17
            }else{
              return 15
            }
          }
        })
        // .style("font-size", (d) => (d.group === 2 ? "20" : "15"))
        ;

      const label2 = svg
        .append("g")
        .selectAll("text")
        .data(this.netChartNodes)
        .enter()
        .append("text")
        .attr("dy", (d) => (d.group === 2 ? 0 : 4))
        .attr("text-anchor", "middle")
        .attr("transform", function(d){
          if(d.group === 2)
            return `translate(0, 7)`
          else {
            if(d.rank == 1){
              return `translate(0, 5)`
            }else if(d.rank > 1 && d.rank < 4){
              return `translate(0, 2)`
            }else if(d.rank > 3 && d.rank < 7){
              return `translate(0, 1)`
            }else{
              return `translate(0, -1)`
            }
          }
        })
        .text(function(d){
          if(d.group === 2){
            if(d.gubun === "nothing"){
              return ""
            }else{
              return d.freq.toLocaleString()
            }
          }else{
            return ""
          }
        })
        .attr("fill", (d) => (d.group === 3 ? "#FFFFFF" : "#707070"))
        .attr("stroke", (d) => (d.group === 3 ? "none" : "#707070"))
        .attr("stroke-width", (d) => (d.group === 3 ? "none" : 0.3))
        .style("font-size", function(d){
          if(d.group == 2){
            return 17
          }else{
            if(d.rank == 1){
              return 17
            }else if(d.rank > 1 && d.rank < 4){
              return 15
            }else if(d.rank > 3 && d.rank < 7){
              return 13
            }else{
              return 11
            }
          }
        })
        ;
      
      
      
      
      
      
      
      
      
      
      
      //////////////////////////////////////////////////////////////////////////////////////////////////


      simulation.on("tick", () => {
        link
          .attr("x1", (d) => d.source.x)
          .attr("y1", (d) => d.source.y)
          .attr("x2", (d) => d.target.x)
          .attr("y2", (d) => d.target.y);

        nodeCircles.attr("cx", (d) => d.x).attr("cy", (d) => d.y);


        nodeRectangles.attr("transform", function(d){
          if(d.rank == 1){
            if(d.id.length < 4){
              var newX = (d.x-(d.freq.toLocaleString().length*30/2))
              var newY = (d.y-30)
              return 'translate('+newX+', '+newY+')'
            }else{
              var newX = (d.x-(d.id.length*30/2))
              var newY = (d.y-30)
              return 'translate('+newX+', '+newY+')'
            }
          }else if(d.rank > 1 && d.rank < 4){
            if(d.id.length < 4){
              var newX = (d.x-(d.freq.toLocaleString().length*25/2))
              var newY = (d.y-20)
              return 'translate('+newX+', '+newY+')'
            }else{
              var newX = (d.x-(d.id.length*25/2))
              var newY = (d.y-20)
              return 'translate('+newX+', '+newY+')'
            }
          }else if(d.rank > 3 && d.rank < 7){
            if(d.id.length < 4){
              var newX = (d.x-(d.freq.toLocaleString().length*20/2))
              var newY = (d.y-15)
              return 'translate('+newX+', '+newY+')'
            }else{
              var newX = (d.x-(d.id.length*20/2))
              var newY = (d.y-15)
              return 'translate('+newX+', '+newY+')'
            }
          }else{
            if(d.id.length < 4){
              var newX = (d.x-(d.freq.toLocaleString().length*15/2))
              var newY = (d.y-10)
              return 'translate('+newX+', '+newY+')'
            }else{
              var newX = (d.x-(d.id.length*15/2))
              var newY = (d.y-10)
              return 'translate('+newX+', '+newY+')'
            }
          }
        });


        
        label.attr("x", (d) => d.x).attr("y", (d) => d.y);
        label2.attr("x", (d) => d.x).attr("y", (d) => (d.y+15));
        
      });
    },
    createGraph() {
      console.log('createGraph!!!');
      
      const width = 600;
      const height = 600;

      const svg = d3
        .select(this.$refs.brandpinChartNet2)
        .append("svg")
        .attr("width", width)
        .attr("height", height);

      const simulation = d3
        .forceSimulation(this.nodes)
        .force(
          "link",
          d3.forceLink(this.links).id((d) => d.id).distance(50)
        )
        .force("charge", d3.forceManyBody().strength(-400))
        .force("center", d3.forceCenter(width / 2, height / 2));

      const link = svg
        .append("g")
        .selectAll("line")
        .data(this.links)
        .enter()
        .append("line")
        .attr("stroke-width", 0)
        .attr("stroke", "#aaa");

      // const node = svg
      //   .append("g")
      //   .selectAll("circle")
      //   .data(this.nodes)
      //   .enter()
      //   .append("circle")
      //   .attr("r", 20)
      //   .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "#1f77b4"))
      //   .call(
      //     d3
      //       .drag()
      //       .on("start", (event, d) => {
      //         if (!event.active) simulation.alphaTarget(0.3).restart();
      //         d.fx = d.x;
      //         d.fy = d.y;
      //       })
      //       .on("drag", (event, d) => {
      //         d.fx = event.x;
      //         d.fy = event.y;
      //       })
      //       .on("end", (event, d) => {
      //         if (!event.active) simulation.alphaTarget(0);
      //         d.fx = null;
      //         d.fy = null;
      //       })
      //   );

      const nodeCircles = svg
        .append("g")
        .selectAll("circle")
        .data(this.nodes)
        .enter()
        .filter(d => d.group != 3)
        .append("circle")
        .attr("r", 20)
        .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "none"))
        .attr('stroke', (d) => (d.group === 1 ? "none" : "#ff7f0e"))
        .attr('stroke-width', (d) => (d.group === 1 ? "none" : 2))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        );

      const nodeRectangles = svg
        .append("g")
        .selectAll("rect")
        .data(this.nodes)
        .enter()
        .filter(d => d.group === 3)
        .append("rect")
        .attr('width', 40)
        .attr('height', 40)
        // .attr('stroke', '#252525')
        // .attr('stroke-width', 2)
        .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "#1f77b4"))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        );

      
      
      const label = svg
        .append("g")
        .selectAll("text")
        .data(this.nodes)
        .enter()
        .append("text")
        .attr("dy", 4)
        .attr("text-anchor", "middle")
        .text((d) => d.id);

      simulation.on("tick", () => {
        link
          .attr("x1", (d) => d.source.x)
          .attr("y1", (d) => d.source.y)
          .attr("x2", (d) => d.target.x)
          .attr("y2", (d) => d.target.y);

        // node.attr("cx", (d) => d.x).attr("cy", (d) => d.y);
        nodeCircles.attr("cx", (d) => d.x).attr("cy", (d) => d.y);
        nodeRectangles.attr("x", (d) => d.x).attr("y", (d) => d.y).attr('transform', 'translate(-10, -7)');

        label.attr("x", (d) => d.x).attr("y", (d) => d.y);
      });
    },
  },
};
</script>

<style scoped>
/* SVG 스타일링을 위해 CSS 추가 */
svg {
  background: #CFCFCF;
}



</style>
